import { Component, EventEmitter, Output } from '@angular/core';
import { IconComponent } from '@navstation-portal/shared/ui/components';
import { IconNames } from '@navstation-portal/shared/data-model/ui';

export enum ReorderAction {
  Up = 'Up',
  Down = 'Down',
}

@Component({
  selector: 're-reorder-buttons',
  templateUrl: './reorder-buttons.component.html',
  styleUrls: ['./reorder-buttons.component.css'],
  imports: [IconComponent],
})
export class ReorderButtonsComponent {
  IconNames = IconNames;
  @Output() reorder = new EventEmitter<ReorderAction>();

  reorderAction: typeof ReorderAction = ReorderAction;

  onReorderButtonClick(reorderAction: ReorderAction) {
    this.reorder.emit(reorderAction);
  }
}
